import * as types from '../actions/scansTable';

export default function setScansSearch(field, value) {
  return {
    type: types.SET_SCANS_SEARCH,
    field,
    value,
  };
}
